module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjI5MjkiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcgNi4yOTNsMS43NjgtMS43NjhhLjUuNSAwIDEgMSAuNzA3LjcwN0w3LjcwNyA3bDEuNzY4IDEuNzY4YS41LjUgMCAxIDEtLjcwNy43MDdMNyA3LjcwNyA1LjIzMiA5LjQ3NWEuNS41IDAgMSAxLS43MDctLjcwN0w2LjI5MyA3IDQuNTI1IDUuMjMyYS41LjUgMCAxIDEgLjcwNy0uNzA3TDcgNi4yOTN6TTcgMTMuNWE2LjUgNi41IDAgMSAxIDAtMTMgNi41IDYuNSAwIDAgMSAwIDEzem0wLTFhNS41IDUuNSAwIDEgMCAwLTExIDUuNSA1LjUgMCAwIDAgMCAxMXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery-close.svg
// module id = 89ZR
// module chunks = 0